import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { fetchTaskList } from '../../../../redux/myCourse/myCourse.actions';
import TaskRows from './taskRows';
import { changeActiveCourse } from '../../../../redux/changeCourse/changeCourse.actions';
import { getParameterByName } from '../../../../utils/commonFunctions';

const AssignmentHistory = ({ fetchTaskList, taskList, changeActiveCourse }) => {
	useEffect(() => {
		const setActiveCourse = async () => {
			await changeActiveCourse(
				getParameterByName('course_id'),
				'FETCH_TASK_DETAILS_PENDING',
			);
		};
		document.getElementById('chat-circle').style.display = 'block';
		if (!!getParameterByName('course_id')) {
			setActiveCourse();
		} else {
			fetchTaskList();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [changeActiveCourse, getParameterByName('course_id'), fetchTaskList]);

	return (
		<div>
			<div className="coach-table-title">Coach Course &#707; Submit a Task</div>
			{!!taskList && taskList.length > 0 ? (
				<div className="table-responsive table-bordered">
					<table className="table">
						<thead>
							<tr>
								<th>Task Name</th>
								<th>Date Assigned</th>
								<th>Date Submitted</th>
								<th>Task Status</th>
							</tr>
						</thead>
						<tbody>
							{taskList.map((task) => (
								<TaskRows key={task.schedule_id} {...task} />
							))}
						</tbody>
					</table>
				</div>
			) : (
				<div>
					{' '}
					No assignments yet. Our Coach will assign you a task once your call is
					completed.
				</div>
			)}
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		taskList: state.rootReducer.myCourse.taskList,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchTaskList: () => dispatch(fetchTaskList()),
		changeActiveCourse: (id, callback) =>
			dispatch(changeActiveCourse(id, callback)),
	};
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
	AssignmentHistory,
);
